import FetchInterceptor from "configs/FetchInterceptor";

class StockUnitsServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/units/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v1/units/get/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }

  static async getByIds(requestBody) {
    const apiUrl = `/core/v1/units/get/data`;
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/units/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async update(requestBody) {
    const apiUrl = "/core/v1/units/update";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
}

export default StockUnitsServices;
